/* eslint-disable react-hooks/exhaustive-deps */
import { RESOURCE_MODULE_IDS } from "config/constants";
import { useEffect, useState } from "react";

const useReasonsForPenalizeByResourceOrSpace = ({
	data: {
		libraryReasonsForPenalize,
		universitySpaceReasonsForPenalize,
	},
	updatePenaltyDialog,
	currentPenaltyForm
}) => {
	const [reasonsForPenalizeByResourceOrSpace, setReasonsForPenalizeByResourceOrSpace] = useState([]);
	useEffect(() => {
		if (updatePenaltyDialog.value)
			setupData();
	}, [updatePenaltyDialog.value]);
	function setupData() {
		switch (currentPenaltyForm.resourceModule.id) {
			case RESOURCE_MODULE_IDS.UNIVERSITY_SPACES:
				setReasonsForPenalizeByResourceOrSpace(universitySpaceReasonsForPenalize);
				break;
			case RESOURCE_MODULE_IDS.LIBRARY:
				setupLibraryData();
				break;
			default: break;
		}
	}
	function setupLibraryData() {
		const data = libraryReasonsForPenalize.filter(({ resourceTypeId }) => resourceTypeId === currentPenaltyForm.library.resourceType.id);
		setReasonsForPenalizeByResourceOrSpace(data);				
	}
	return reasonsForPenalizeByResourceOrSpace;
}	
	
export default useReasonsForPenalizeByResourceOrSpace;